<template>
    <el-container style="position: relative;background: linear-gradient(to bottom, #aaaeb1, #eeeeee);">
        <el-main class="body-main" style="padding: 10px;">
            <div class="body-main_div">
                <div class="body-main_content" style="padding: 15px">
                    <el-carousel height="360px" style="width: 100%;height: 360px;border-bottom: 1px solid #bfbfbf;">
                        <el-carousel-item  v-for="(item,index) in showNotice" :key="index">
                            <div class="allItem" @click="goDetail(item)">
                                <el-image :src="item.picUrl" fit="cover"></el-image>
                                <div class="all-title">
                                    <div style="margin-top:36px;margin-bottom:18px;">
                                        {{ item.title }}
                                    </div>
                                    <div class="all-day" style="margin-bottom:18px;">
                                        {{  changeDay(item.publishTime) }}
                                    </div>
                                    <div style="color: #999999;font-size: 14px;line-height: 22px;font-weight: 500;">
                                        {{ item.summarize }}
                                    </div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                    <div class="list-item" @click="goDetail(item)" v-for="(item,index) in noticeList" :key="index">
                        <div style="display: flex;">
                            <el-image :src="item.picUrl" fit="cover"></el-image>
                            <div class="list-center">
                                <div class="list-title">{{ item.title }}</div>
                                <div class="list-summarize">{{ item.summarize }}</div>
                            </div>
                        </div>
                        <div class="list-right">
                            <div class="right-big">{{  changeDay(item.publishTime).slice(8,10) }}</div>
                            <div>{{  changeDay(item.publishTime).slice(0,7) }}</div>
                        </div>
                    </div>
                    <el-footer style="display: flex;justify-content: end;height: auto;width: 100%;margin: 15px;">
                        <table-page
                            ref="noticeListPage"
                            :url="noticeListUrl"
                            :form="form"
                            :urlDafault="true"
                            @page-change="convert"
                        ></table-page>
                    </el-footer>
                </div>
            </div>
        <!-- <div class="footCss"></div> -->
        </el-main>
    </el-container>
</template>

<script>
import TablePage from "@/components/TablePage";
import moment from "moment";
export default {
    name: 'noticeLists',
    components: {
        TablePage,
    },
    data(){
        return {
            noticeList: [],
            showNotice: [],
            form: {
                status: 50,
                filterNotice: 'Y'
            },
            noticeListUrl: this.global.BASE_URL_2971 + "/msi/cms/web/article/findWebArticle",
        }
    },
    methods : {
        goDetail(row) {
            const route = this.$router.resolve({ path: `/news/${row.articleId}`  });
            window.open(route.href, '_blank');
        },
        search(params) {
            this.$nextTick(()=>{
                this.$refs["noticeListPage"].getTableData(params);
            })
        },
        convert(tableData) {
            this.showNotice = tableData.data.slice(0,3);
            this.noticeList = tableData.data;
            console.log(this.noticeList,this.showNotice,'show')
        },
        changeDay(row){
            if(!row){
                return ''
            }
            let date = moment(row).format('yyyy-MM-DD')
            return date
        }
    }
}
</script>

<style lang="less" scoped>
.body-main {
    display: flex;
    justify-content: center;

    .body-main_div {
        min-height: calc(100vh - 162px);
        width: 1216px;
        background-color: #fff;
        cursor: pointer;
        border-radius: 8px;

        .body-main_content {
            flex-flow: wrap;
            display: flex;

            .allItem {
            display: flex;
            justify-content: start;
            background-color: #fff;

            .el-image {
                width: 480px;
                margin-right: 20px;
            }

            .all-title {
                font-size: 22px;
                font-weight: 600;
                color:#bb0009;
                margin-left: 30px;
                width: 550px;
                padding-right: 30px;

                .all-day {
                    font-size: 20px;
                    font-weight: 500;
                    color: #595857;
                    margin-top: 20px;
                }
            }
        }

        }

        /deep/ .el-carousel__indicators {
            text-align: right !important;
            bottom: 40px !important;
            right: -35%;
            margin-right: 36px;
        }

        /deep/ .is-active .el-carousel__button {
            background-color: #bb0009 !important;
        }

        /deep/ .el-carousel__button {
            background-color: #595857;
            width: 10px;
            height: 10px;
            border-radius: 2px;
        }

        .list-item {
            display: flex;
            justify-content: space-between;
            width: 100%;
            border-bottom: 1px solid #bfbfbf;
            padding: 30px 0;

            .el-image {
                width: 240px;
                height: 160px;
            }

            .list-center {
                width: 600px;
                font-weight: 500;
                margin-left: 40px;

                .list-title {
                    color: #0e1114;
                    font-size:20px;
                    margin-bottom:18px;
                    // margin-top:36px;
                }

                .list-summarize {
                    color: #999999;
                    font-size: 14px;
                    line-height: 22px;
                }
            }

            .list-right {
                border-left: 1px solid#bb0009;
                padding-left: 40px;
                padding-right:40px;

                .right-big {
                    font-size: 44px;
                    margin-top: 40px;
                }
            }
        }
    }
}
.footCss {
  position: absolute;
  bottom: 0;
  width: 1210px;
  margin: 0 auto;
  left: 0;
  right: 0;
  height: 106px;
  box-sizing: border-box;
  background: url(../../assets/images/red-footer-background.png) no-repeat;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/main/notice-list.vue